(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.selectMenu = {
    attach: function (context, settings) {

      $('.select-menu', context).change(function() {
        // The first item is for display purposes only.
        const index = $(this).prop('selectedIndex');
        if (index != 0) {
          window.location = $(this).val();
        }
      });

    }
  };

})(jQuery, Drupal);
